export const PRIVACY_ID = {
    PRIVACY_NOTICE: 'a0d0f8d0e18e11ec8bf4fa163e89e3c8',
    HR_POLICY: 'ae39d1b4e18e11ec8bf4fa163e89e3c8',
    COOKIES_POLICY: 'b28de414e18e11ec8bf4fa163e89e3c8',
    CCTV_POLICY: 'b77d2406e18e11ec8bf4fa163e89e3c8',
    RECRUITMENT_POLICY: 'bb51a3ade18e11ec8bf4fa163e89e3c8',
    VENDOR_POLICY: 'bf092d3ce18e11ec8bf4fa163e89e3c8',
    DPA: 'c5ff542de18e11ec8bf4fa163e89e3c8',
    FREE_FORM: 'c24c3112a12a457aa4a58d364f56ecbf',
};

export const POLICY_NAME_BY_ID = {
    a0d0f8d0e18e11ec8bf4fa163e89e3c8: 'privacy-notice',
    ae39d1b4e18e11ec8bf4fa163e89e3c8: 'hr-policy',
    b28de414e18e11ec8bf4fa163e89e3c8: 'cookies-policy',
    b77d2406e18e11ec8bf4fa163e89e3c8: 'cctv-policy',
    bb51a3ade18e11ec8bf4fa163e89e3c8: 'recruitment-policy',
    bf092d3ce18e11ec8bf4fa163e89e3c8: 'vendor-policy',
    c5ff542de18e11ec8bf4fa163e89e3c8: 'dpa',
    c24c3112a12a457aa4a58d364f56ecbf: 'free-form',
};

export const POLICY_NAME = {
    PRIVACY_NOTICE: 'privacy-notice',
    HR_POLICY: 'hr-policy',
    COOKIES_POLICY: 'cookies-policy',
    CCTV_POLICY: 'cctv-policy',
    RECRUITMENT_POLICY: 'recruitment-policy',
    VENDOR_POLICY: 'vendor-policy',
    DPA: 'dpa',
    FREE_FORM: 'free-form',
};

export const COUNT_NAME = {
    PRIVACY: 'privacyPolicy',
    PRIVACY_NOTICE: 'privacyPolicyNotice',
    COOKIES_POLICY: 'cookiePolicy',
    HR_POLICY: 'hrPrivacyPolicy',
    RECRUITMENT_POLICY: 'recruitmentPrivacyPolicy',
    VENDOR_POLICY: 'vendorPrivacyPolicy',
    DPA: 'dataProcessingAgreement',
    CCTV_POLICY: 'cctvPolicy',
    FREE_FORM: 'freeFormPolicy',
};
